import React, { FC, useRef } from 'react';
import GameMenuTile from './GameMenuTile';
import { Paragraph } from '../../../shared/Paragraph';
import { Tooltip } from '../../../shared/Tooltip';
import { DepositButton } from '../../../shared/DepositButton';
import { CashIcon } from '../../../shared/SVG/Icons';
import { useDispatch } from 'react-redux';
import { setCashierModal } from '../../../../state/cashier/reducers';
import { CashierType } from '../../../../state/cashier';
import { useUserBalance } from '../../../../hooks/useUserBalance';
import { Balance } from '../../../shared/Balance';
import './styles';
import { useTranslations } from '../../../../hooks/useTranslationsHelper';

type GameMenuBalanceProps = {
  /**
   * Callback that's executed when the account is requested to close
   */
  closeMenu?: () => void;
  /**
   * Callback that's executed when the account is requested to open
   */
  openDeposit?: () => void;
  showBonusDetails?: boolean;
};

const GameMenuBalance: FC<GameMenuBalanceProps> = ({ showBonusDetails = true }): JSX.Element => {
  const { t } = useTranslations();
  const { isBalanceLoading, userBalance } = useUserBalance();

  const dispatch = useDispatch();
  const scrollRef = useRef<HTMLDivElement>(null);
  const expandedItems = useRef<number>(0);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onItemExpand = (state: boolean): void => {
    expandedItems.current += state ? 1 : -1;
    const showState = expandedItems.current > 0;

    if (scrollRef && scrollRef.current && !showState) {
      scrollRef.current.scrollTo(0, 0);
    }
  };

  const onDepositBtnClick = (): void => {
    dispatch(setCashierModal({ isOpen: true, type: CashierType.Deposit }));
  };

  const onShowCashInfo = (): void => {
    console.log('onShowCashInfo');
  };

  return (
    <div className="game-menu-balance">
      <div className="game-menu-balance__cash">
        <GameMenuTile>
          <>
            <div className="game-menu-balance__content-wrap">
              <CashIcon />
              <div className="game-menu-balance__content">
                <div className="game-menu-balance__text-tooltip-wrap">
                  <Paragraph size="xs" highlight className="game-menu-balance__balance-type">
                    {t('balance.cash-balance')}
                  </Paragraph>
                  <Tooltip
                    position="right"
                    buttonProps={{ 'aria-label': 'Info icon label' }}
                    onShow={onShowCashInfo}
                    className="game-menu-balance__tooltip"
                  >
                    {t('balance.tooltip')}
                  </Tooltip>
                </div>
                <Balance
                  isHeading
                  isLoading={isBalanceLoading}
                  balance={userBalance.mainCashBalance + userBalance.lockedCashBalance}
                  className="game-menu-balance__balance"
                />
              </div>
            </div>
            <DepositButton className="game-menu-balance__button" onClick={onDepositBtnClick} />
          </>
        </GameMenuTile>
      </div>
    </div>
  );
};

export default GameMenuBalance;
